import {
  Heading,
  Modal,
  SelectBox,
  Text,
  Button,
  ButtonType,
  Badge,
  BADGE_KIND,
} from '@saasalerts/ui'
import { useState } from 'react'
import { faXmark } from '@awesome.me/kit-e270131d0a/icons/classic/regular'

type SelectFilterWithModalProps = {
  options: { id: string; name: string }[] | undefined
  onUpdate: (items: string[]) => void
  selectedItems: string[]
  labels: {
    heading: string
    items: string
  }
}

export const SelectFilterWithModal = ({
  options,
  onUpdate,
  selectedItems,
  labels,
}: SelectFilterWithModalProps) => {
  const [open, setOpen] = useState(false)

  const handleAddItem = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onUpdate([...selectedItems, e.target.value])

    // Remove focus from the SelectBox
    e.target.blur()
  }

  const handleRemoveItem = (item: string) => {
    onUpdate(selectedItems.filter((si) => si !== item))
  }
  return (
    <>
      <div className="flex items-end justify-end gap-4">
        <div className="w-72">
          <SelectBox
            label={labels.heading}
            name="Basic"
            onChange={handleAddItem}
            options={options}
          />
        </div>

        {selectedItems.length > 0 && (
          <>
            <Button
              kind={ButtonType.SOLID_BRAND}
              onClick={() => setOpen(true)}
              tooltip={{
                content: 'Click to Edit',
              }}
            >
              {selectedItems.length} {labels.items} selected
            </Button>
          </>
        )}
      </div>

      <Modal open={open} setOpen={setOpen} size="sm">
        <Modal.Header>
          <Modal.TitleBar>
            <Heading type="h2">{labels.heading}</Heading>
          </Modal.TitleBar>
        </Modal.Header>
        <Modal.Body>
          {selectedItems.length > 0 ? (
            <div className="flex flex-wrap items-center gap-2">
              {selectedItems.map((item: string, i: number) => {
                return (
                  <div
                    key={`${item}-${i}`}
                    onClick={() => handleRemoveItem(item)}
                    className="cursor-pointer"
                  >
                    <Badge
                      text={item}
                      kind={BADGE_KIND.MIDNIGHT}
                      variant="subtle"
                      icon={faXmark}
                      iconPosition="right"
                      size="small"
                    />
                  </div>
                )
              })}
            </div>
          ) : (
            <Text>No {labels.items} selected</Text>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            kind={ButtonType.OUTLINE_WHITE}
            onClick={() => {
              setOpen(false)
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
